export enum GenUserGroup {
  restrictedCheckoutGroup = 'restrictedcheckoutgroup',
  restrictedplaceordergroup = 'restrictedplaceordergroup',
  testorderplacegroup = 'testorderplacegroup',
  netPricingRestrictedGroup = 'netpricingrestrictedgroup',
  savedaddresschangerestrictedgroup = 'savedaddresschangerestrictedgroup'
}
